import React, { useState } from 'react';
import { Button, Select, Table, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;

const data = [
  { key: "1", sno: "", particulars: "", sixmonthtothreemonth: "", sixmonthtothreemonthsam: "", sixyeartothreeyear: "", sixyeartothreeyearsam: "" },
  { key: "2", sno: "", particulars: "", sixmonthtothreemonth: "", sixmonthtothreemonthsam: "", sixyeartothreeyear: "", sixyeartothreeyearsam: "" },
  { key: "3", sno: "", particulars: "", sixmonthtothreemonth: "", sixmonthtothreemonthsam: "", sixyeartothreeyear: "", sixyeartothreeyearsam: "" },
  { key: "4", sno: "", particulars: "", sixmonthtothreemonth: "", sixmonthtothreemonthsam: "", sixyeartothreeyear: "", sixyeartothreeyearsam: "" },
];

const columns = [
  { title: "6m-3y", dataIndex: "sixmonthtothreemonth", key: "sixmonthtothreemonth", align: "center", },
  { title: "6m-3y Sam", dataIndex: "sixmonthtothreemonthsam", key: "sixmonthtothreemonthsam", align: "center" },
  { title: "3y-6y", dataIndex: "sixyeartothreeyear", key: "sixyeartothreeyear", align: "center" },
  { title: "3y-6y Sam", dataIndex: "sixyeartothreeyearsam", key: "sixyeartothreeyearsam", align: "center", },
];

const months = ["AUG", "May", "June", "July"];

const RM_Table = () => {
  const [selected, setSelected] = useState();
  const navigate=useNavigate();

  const handleSelect = (value) => {
    setSelected(value);
    
    navigate(`/master/raw-material-planning/rm-tabs/${value}`);
  };

  return (
    <div style={{ background: "#fff", minHeight: "100vh", padding: 28 }}>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 16 }}>
        <span style={{ color: "#1463A3", fontWeight: "bold", fontSize: 17, letterSpacing: "1px" }}>KTKKAR0825</span>
        <span style={{ color: "#232c29", fontWeight: "bold", fontSize: 17 }}>JUN 2025</span>
        <span style={{ color: "#232c29", fontWeight: "bold", fontSize: 17 }}>140000</span>
        <Button
          style={{
            background: "#fff",
            border: "2px solid #063253",
            color: "#063253",
            fontWeight: "bold",
            borderRadius: "7px",
            marginLeft: 16,
            minWidth: "110px",
            boxShadow: "0 1.5px 5px #d6e0ee"
          }}
        >
          Pushtii
        </Button>
      </div>

      {/* Dropdown Row */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: 7 }}>
        <Typography.Text style={{ color: "#bababa", fontWeight: 500, marginRight: 10 }}>
          Select From Serving PD Master
        </Typography.Text>
        <Select
          style={{
            width: 160,
            borderRadius: 7,
            fontWeight: 500,
            fontSize: 15
          }}
          placeholder="Dropdown"
          size="large"
          value={selected}
          onChange={handleSelect}
        >
          {months.map(m => (
            <Option key={m} value={m}>{`Pushti - ${m}`}</Option>
          ))}
        </Select>
      </div>

      {/* Table */}
      <div style={{ borderRadius: 10, overflow: "hidden", marginTop: 10 }}>
        <Table
  columns={columns}
  dataSource={data}
  bordered
  pagination={false}
  style={{
    color: "#363636", // lowercase 'color'
    fontSize: "16px",
  }}
  rowClassName={() => "custom-row"}
/>
      </div>
    </div>
  );
};

export default RM_Table;
